import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { HttpClient } from "@angular/common/http";
import { UserService } from "./user.service";
import { DataCommission, SystemCommission, Transaction, adspCommission, bdspCommission, AdServiceFee, Commission, tdspCommission } from "src/app/models/user";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class AdvertiserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/advertiser/`;
  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  addCredit(credit: Transaction, id) {
    let url = `${this.resource_url}${id}/credit/`
    return this.post(url, credit);
  }

  addDebit(debit: Transaction, id) {
    let url = `${this.resource_url}${id}/debit/`
    return this.post(url, debit);
  }

  getBalance(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/balance/`, '', params)
    return this.get(url);
  }

  getAccountStatement(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/account-statement/`, '', params)
    return this.get(url);
  }

  getInvoiceStatement(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/account-invoice/`, '', params)
    return this.get(url);
  }

  getSystemCommission(id) {
    let url = `${this.resource_url}${id}/sc/`
    return this.get(url);
  }

  getCommissionHistory(id) {
    let url = `${this.resource_url}${id}/commission-history/`;
    return this.get(url);
  }

  setSystemCommission(id, commission: SystemCommission) {
    let url = `${this.resource_url}${id}/sc/`
    return this.put(url, commission);
  }

  getPrivateDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`
    return this.get(url);
  }

  setPrivateDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-cdc/`
    return this.put(url, commission);
  }

  getRegularDealCommission(id) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`
    return this.get(url);
  }

  setRegularDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/vdsp-sdc/`
    return this.put(url, commission);
  }

  getDataCommission(id) {
    let url = `${this.resource_url}${id}/dc/`
    return this.get(url);
  }

  setDataCommission(id, commission: DataCommission) {
    let url = `${this.resource_url}${id}/dc/`
    return this.put(url, commission);
  }

  getOfflineCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/vdsp-oc/`, '', params)
    return this.get(url);
  }

  setOfflineCommission(id, commission) {
    let url = `${this.resource_url}${id}/vdsp-oc/`
    return this.put(url, commission);
  }

  getAdspSystemCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-sc/`, '', params)
    return this.get(url);
  }

  getAdspTagId(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-tag-id/`, '', params)
    return this.get(url);
  }

  setAdspSystemCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-sc/`
    return this.put(url, commission);
  }

  getAdspDataCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dc/`, '', params)
    return this.get(url);
  }

  setAdspDataCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dc/`
    return this.put(url, commission);
  }

  getAdspContractCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-cc/`, '', params)
    return this.get(url);
  }

  setAdspContractCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-cc/`
    return this.put(url, commission);
  }

  getAdspDealCommission(id, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/adsp-dlc/`, '', params)
    return this.get(url);
  }

  setAdspDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/adsp-dlc/`
    return this.put(url, commission);
  }

  getBdspContractCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cc/`
    return this.get(url);
  }

  setBdspContractCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cc/`
    return this.put(url, commission);
  }

  getBdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sc/`
    return this.get(url);
  }

  setBdspSystemCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sc/`
    return this.put(url, commission);
  }

  getBdspDataCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-dc/`
    return this.get(url);
  }

  setBdspDataCommission(id, commission: bdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-dc/`
    return this.put(url, commission);
  }

  getBdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`
    return this.get(url);
  }

  setBdspContractDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/bdsp-cdc/`
    return this.put(url, commission);
  }

  getBdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`
    return this.get(url);
  }

  setBdspSystemDealCommission(id, commission: adspCommission) {
    let url = `${this.resource_url}${id}/bdsp-sdc/`
    return this.put(url, commission);
  }

  getBdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.get(url);
  }

  setBdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/bdsp-agency-comm/`
    return this.put(url, commission);
  }

  getTdspContractCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cc/`
    return this.get(url);
  }

  setTdspContractCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cc/`
    return this.put(url, commission);
  }

  getTdspSystemCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sc/`
    return this.get(url);
  }

  setTdspSystemCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sc/`
    return this.put(url, commission);
  }

  getTdspDataCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-dc/`
    return this.get(url);
  }

  setTdspDataCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-dc/`
    return this.put(url, commission);
  }

  getTdspContractDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`
    return this.get(url);
  }

  setTdspContractDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-cdc/`
    return this.put(url, commission);
  }

  getTdspSystemDealCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`
    return this.get(url);
  }

  setTdspSystemDealCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-sdc/`
    return this.put(url, commission);
  }

  getTdspAgencyCommission(id) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.get(url);
  }

  setTdspAgencyCommission(id, commission: tdspCommission) {
    let url = `${this.resource_url}${id}/tdsp-agency-comm/`
    return this.put(url, commission);
  }

  getAdServiceFee(id, type: string, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, '', params);
    return this.get(url);
  }
  setAdServiceFee(id, type: string, adServiceFee: AdServiceFee, params = {}) {
    let url = this.buildUrl(`${this.resource_url}${id}/${type}/`, '', params);
    return this.put(url, adServiceFee)
  }

}

@Injectable({
  providedIn: "root",
})
export class AdvertiserUserService extends BaseEntityService {
  public resource_url = `${this.BASE_API_URL}/advertiser/users/`;

  constructor(
    public http: HttpClient,
    public toastr: NotificationService,
    public userService: UserService
  ) {
    super();
  }

  updateLicense(data, params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, '', params)
    return this.put(url, data);
  }

  getUserClickAccess(params) {
    let url = this.buildUrl(`${this.resource_url}qlik-access/`, '', params)
    return this.get(url);
  }
}

// advertiser-helper.service.ts
@Injectable({ providedIn: 'root' })
export class AdvertiserHelperService {
  targetingEU: boolean = false;
  isAdvPayer: boolean = false;
  gamblingAddendumContractId: number;
  adv_category: any;

  constructor() { }

 prepareAdvertiser(advertiser: any, legacy_user = false): any {

  if (advertiser.tier === 'lite') {
    delete advertiser.config;
    delete advertiser.management_type;
  } else {
    delete advertiser.config?.override_msa_check;
  }

  if (advertiser.adsp_enabled && !advertiser.apnx_enabled) {
    advertiser.apnx_commission.contract_commission = 0;
  }

  // ADSP
  if (!advertiser.adsp_enabled) {
    advertiser.adsp_details = null;
    advertiser.adsp_region = null;
    advertiser.adsp_target_country = null;
  } 
  else if (advertiser.adsp_details) {
    delete advertiser.adsp_details.vizibl_category_id;
    delete advertiser.adsp_details.vizibl_subcategory_id;
   if (!legacy_user) {
    advertiser.adsp_details.industry = null;
  }
  }

  // APNX
  if (!advertiser.apnx_enabled) {
    advertiser.apnx_commission = new Commission();
  }

  // BDSP
  advertiser.bdsp_category = advertiser.bdsp_category ?? null;

  if (!advertiser.bdsp_enabled) {
    advertiser.bdsp_category = null;
  } 
  else if (advertiser.bdsp_category_id) {
    const selected = this.adv_category?.find(
      (c) => c.id === advertiser.bdsp_category_id
    );

    advertiser.bdsp_category = selected ? selected.key : null;
  }

  // TDSP
  if (!advertiser.tdsp_enabled) {
    advertiser.tdsp_details = null;
  } 
  else {

    this.targetingEU = advertiser.tdsp_details.targetingEU;
    this.isAdvPayer = advertiser.tdsp_details.isAdvPayer;

    delete advertiser.tdsp_details.targetingEU;
    delete advertiser.tdsp_details.isAdvPayer;

    if (advertiser.tdsp_details.run_political_ads) {

      if (!this.targetingEU) {
        advertiser.tdsp_details.eu_advertiser_name = null;
        advertiser.tdsp_details.payer_name = null;
      }

      if (this.isAdvPayer) {
        advertiser.tdsp_details.payer_name = null;
      }

    } 
    else {
      advertiser.tdsp_details.eu_advertiser_name = null;
      advertiser.tdsp_details.payer_name = null;
    }

    if (!legacy_user) {

      if (
        advertiser.tdsp_details?.category_parent_id &&
        advertiser.vizibl_category_ids == null
      ) {
        advertiser.vizibl_category_ids = [
          advertiser.tdsp_details.category_parent_id
        ];

        advertiser.vizibl_subcategory_id =
          advertiser.tdsp_details.category_id;
      }

    } 
    else {
      delete advertiser.vizibl_category_ids;
      delete advertiser.vizibl_subcategory_id;
    }
  }

  if (
    advertiser.vizibl_category_ids != null &&
    !Array.isArray(advertiser.vizibl_category_ids)
  ) {
    advertiser.vizibl_category_ids = [advertiser.vizibl_category_ids];
  }

  return advertiser;
}

  restoreTdsp(advertiser: any) {
    if (advertiser?.tdsp_details) {
      advertiser.tdsp_details.targetingEU = this.targetingEU;
      advertiser.tdsp_details.isAdvPayer = this.isAdvPayer;
    }
  }
}

